module.exports = __webpack_public_path__ + "media/images/athletes/1901-d4036e1b1145b1bb939c59b88098436f.png";